import React from 'react';
import SolutionDepositCheckContainer from 'containers/SolutionDepositCheckContainer';

export default function SolutionDepositCheckPage() {
  return (
    <SolutionDepositCheckContainer />
  )
}
